import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgFormComponent } from './pg-form.component';
import { PgFormSectionComponent } from './pg-form-section.component';
import { PgFormRowComponent } from './pg-form-row.component';
import { PgFormColComponent } from './pg-form-col.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    PgFormComponent,
    PgFormSectionComponent,
    PgFormRowComponent,
    PgFormColComponent,
  ],
  exports: [
    PgFormComponent,
    PgFormSectionComponent,
    PgFormRowComponent,
    PgFormColComponent,
  ],
})
export class PgFormModule {}
